// app.states.js

"use strict";

const home = {
    name: "home",
    url: "/",
    component: "areaCliente",
    redirectTo: "areaCliente.inicioSesion",
    lazyLoad: ($transition$) => {
      const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
      return import(/* webpackChunkName: "area-cliente.module" */ "./components/area-cliente/area-cliente.module")
        .then(mod => $ocLazyLoad.inject(mod.HOME_MODULE))
        .catch(err => {
          throw new Error("Ooops, something went wrong, " + err);
        });
    },
    onEnter: ["$document", ($document) => {
      $document[0].title = "Energía El Corte Inglés";
      $document[0].querySelector('meta[name="description"]').setAttribute('content', 'Únete a Energía El Corte Inglés y tendrás el precio y la atención de calidad que te mereces con todas las garantías del Grupo El Corte Inglés');
      $document[0].querySelector('meta[name="keyword"]').setAttribute('content', 'Energia El Corte Ingles, Luz El Corte Ingles, Electrica el corte ingles, Electricidad el corte ingles, Luz el corte ingles, Cambiar compañia luz, Electricas');
      $document[0].querySelector('link[rel="canonical"]').setAttribute('href', 'https://energiaelcorteingles.es');
      $document[0].querySelector('script[type="application/ld+json"]').innerText = '{"@context": "https://schema.org","@graph":[{"@type": "Corporation","@id": "https://energiaelcorteingles.es","legalName": "","description": "","url": "https://energiaelcorteingles.es","address":{"@type": "PostalAddress","addressLocality": "Spain","addressCountry": "ES","postalCode": "","streetAddress": ""},"logo": "","sameAs":["https://www.facebook.com/energiaelcorteingles","https://twitter.com/energiaelcorteingles","https://www.instagram.com/energiaelcorteingles","https://www.youtube.com/channel/UCbi7cIi_LUZkDxOx9CvbpDg","https://www.linkedin.com/company/energiaelcorteingles"]},{"@type": "WebSite","name": "Unete a Energia El Corte Ingles y tendras el precio y la atencion de calidad que te mereces con todas las garantias del Grupo El Corte Ingles","url": "https://energiaelcorteingles.es"}]}';
    }]
};

const areaCliente = {
  name: "areaCliente",
  url: "/login",
  component: "areaCliente",
  redirectTo: "areaCliente.inicioSesion",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
    return import(/* webpackChunkName: "area-cliente.module" */ "./components/area-cliente/area-cliente.module")
      .then(mod => $ocLazyLoad.inject(mod.AREA_CLIENTE_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },
  onEnter: ["$document", ($document) => {
    $document[0].title = "Área de clientes - Energía El Corte Inglés";
    $document[0].querySelector('meta[name="description"]').setAttribute('content', 'Area de cliente de Energia El Corte Ingles');
    $document[0].querySelector('meta[name="keyword"]').setAttribute('content', 'Energia El Corte Ingles clientes, Clientes Energia El Corte Ingles, Area clientes Energia El Corte Ingles');
    $document[0].querySelector('link[rel="canonical"]').setAttribute('href', 'https://energiaelcorteingles.es/areaCliente');
    $document[0].querySelector('script[type="application/ld+json"]').innerText = '{"@context":"https://schema.org/","@id":"https://energiaelcorteingles.es/areaCliente","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"home","item":"https://energiaelcorteingles.es"},{"@type":"ListItem","position":2,"name":"areaCliente","item":"https://energiaelcorteingles.es/areaCliente"}]}';
  }]
};

const areaClienteInicioSesion = {
  name: "areaCliente.inicioSesion",
  url: "/",
  component: "inicioSesion",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
    return import(/* webpackChunkName: "inicio-sesion.module" */ "./components/area-cliente/inicio-sesion/inicio-sesion.module")
      .then(mod => $ocLazyLoad.inject(mod.INICIO_SESION_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },
  onEnter: ["$document", ($document) => {
    $document[0].title = "Área de clientes - Energía El Corte Inglés";
    $document[0].querySelector('meta[name="description"]').setAttribute('content', 'Area de cliente de Energia El Corte Ingles');
    $document[0].querySelector('meta[name="keyword"]').setAttribute('content', 'Energia El Corte Ingles clientes, Clientes Energia El Corte Ingles,  Area clientes Energia El Corte Ingles');
    $document[0].querySelector('link[rel="canonical"]').setAttribute('href', 'https://energiaelcorteingles.es/areaCliente');
    $document[0].querySelector('script[type="application/ld+json"]').innerText = '{"@context":"https://schema.org/","@id":"https://energiaelcorteingles.es/areaCliente","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"home","item":"https://energiaelcorteingles.es"},{"@type":"ListItem","position":2,"name":"areaCliente","item":"https://energiaelcorteingles.es/areaCliente"}]}';
  }]
};

const areaClienteCambiarPass = {
  name: "areaCliente.cambiarPass",
  url: "/cambiarPass",
  component: "cambiarPass",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
    return import(/* webpackChunkName: "acceso.module" */ "./components/area-cliente/cambiar-pass/cambiar-pass.module")
      .then(mod => $ocLazyLoad.inject(mod.CAMBIAR_PASS_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },
  onEnter: ["$document", ($document) => {
    $document[0].title = "Área de clientes - Energía El Corte Inglés";
    $document[0].querySelector('meta[name="description"]').setAttribute('content', 'Area de cliente de Energia El Corte Ingles');
    $document[0].querySelector('meta[name="keyword"]').setAttribute('content', 'Energia El Corte Ingles clientes, Clientes Energia El Corte Ingles, Area clientes Energia El Corte Ingles');
    $document[0].querySelector('link[rel="canonical"]').setAttribute('href', 'https://energiaelcorteingles.es/areaCliente');
    $document[0].querySelector('script[type="application/ld+json"]').innerText = '{"@context":"https://schema.org/","@id":"https://energiaelcorteingles.es/areaCliente","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"home","item":"https://energiaelcorteingles.es"},{"@type":"ListItem","position":2,"name":"areaCliente","item":"https://energiaelcorteingles.es/areaCliente"}]}';
  }]
};

const areaClienteGenerarPass = {
  name: "areaCliente.generarPass",
  url: "/generarPass?token=",
  component: "generarPass",
  lazyLoad: ($transition$) => {
    const $ocLazyLoad = $transition$.injector().get("$ocLazyLoad");
    return import(/* webpackChunkName: "acceso.module" */ "./components/area-cliente/generar-pass/generar-pass.module")
      .then(mod => $ocLazyLoad.inject(mod.GENERAR_PASS_MODULE))
      .catch(err => {
        throw new Error("Ooops, something went wrong, " + err);
      });
  },
  onEnter: ["$document", ($document) => {
    $document[0].title = "Área de clientes - Energía El Corte Inglés";
    $document[0].querySelector('meta[name="description"]').setAttribute('content', 'Area de cliente de Energia El Corte Ingles');
    $document[0].querySelector('meta[name="keyword"]').setAttribute('content', 'Energia El Corte Ingles clientes, Clientes Energia El Corte Ingles, Area clientes Energia El Corte Ingles');
    $document[0].querySelector('link[rel="canonical"]').setAttribute('href', 'https://energiaelcorteingles.es/areaCliente');
    $document[0].querySelector('script[type="application/ld+json"]').innerText = '{"@context":"https://schema.org/","@id":"https://energiaelcorteingles.es/areaCliente","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"home","item":"https://energiaelcorteingles.es"},{"@type":"ListItem","position":2,"name":"areaCliente","item":"https://energiaelcorteingles.es/areaCliente"}]}';
  }]
};

export { home, areaCliente, areaClienteInicioSesion, areaClienteCambiarPass, areaClienteGenerarPass };
